// Preferência do menu lateral no computador (recolhido x aberto).
//
// Antes o estado vivia só em useState(true): F5 reabria o menu, e clicar numa
// aba com o menu recolhido, ou fechar o formulário de produto, abria de novo à
// força. Aqui fica a escolha manual do usuário (botão ☰), guardada no
// navegador. Só vale em tela larga: no celular o menu é uma gaveta e abrir/
// fechar ali não diz nada sobre a preferência do computador.

const CHAVE = "nucleo_menu_lateral_recolhido";
const LARGURA_DESKTOP = 1024; // mesmo corte `lg` do Tailwind usado no Dashboard

export function ehTelaLarga() {
  return typeof window !== "undefined" && window.innerWidth >= LARGURA_DESKTOP;
}

function lerRecolhido() {
  try {
    return localStorage.getItem(CHAVE) === "1";
  } catch (_) {
    return false; // localStorage bloqueado: segue o padrão (aberto)
  }
}

// Estado inicial do menu. No celular mantém o comportamento de sempre (true).
export function menuAbertoInicial() {
  return ehTelaLarga() ? !lerRecolhido() : true;
}

// Como o menu deve ficar depois de navegar/fechar um formulário (só desktop).
export function menuAbertoPreferido() {
  return !lerRecolhido();
}

// Chamado só pelo botão ☰: `aberto` é o estado NOVO escolhido pelo usuário.
export function salvarMenuAberto(aberto) {
  if (!ehTelaLarga()) return;
  try {
    localStorage.setItem(CHAVE, aberto ? "0" : "1");
  } catch (_) {
    /* sem localStorage: a escolha vale só até o F5 */
  }
}
